<template>
    <div class="cuponContainer" :style="{padding: isTabView ? '0px 0px' : '70px 0px 0px'}">
        <CustomHeader v-if="!isTabView" :text="$t('giftCode.exchangeReward')" />
        <div class="gift-banner">
            <img :src="dataSet.bannerIcon" alt="banner" class="banner-img" />

            <div class="middleCard">
                <span class="top-text">{{ $t('giftCode.enterCode') }}</span>

                <van-row class="couponInput">
                    <van-col span="24"><van-field class="pasteInput" :placeholder="$t('giftCode.enterCode')"
                            v-model="couponCode" /></van-col>
                </van-row>

                <div class="btn_container">
                    <MainButton :title="$t('common.register')" :activeStatus="true" @click="claimSubmit" />
                </div>

                <div class="mediaIcons">
                    <img src="@/assets/sideNavbar/Telegram_cai.png" alt="banner" class="media-img" @click="goToShare" />
                    <img src="@/assets/sideNavbar/Whatsapp_cai.png" alt="banner" class="media-img" @click="goToShare" />
                    <img src="@/assets/sideNavbar/facebook_cai.png" alt="banner" class="media-img" @click="goToShare" />
                    <img src="@/assets/bauDo/instagram_icon.png" alt="banner" class="media-img" @click="goToShare" />
                    <img src="@/assets/sideNavbar/18+_cai.png" alt="banner" class="media-img" @click="goToShare" />
                </div>
            </div>
        </div>


        <div class="bottom_text" v-if="dataSet.activityInfo.length > 0">
            <div class="line_text" v-for="(item, index) in dataSet.activityInfo" :key="index">
                {{ item }}
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">

import { GiftCodeData } from '@/view/giftCode/giftCodeView';
import { watch, ref } from 'vue';
import CustomHeader from '../components/common/customHeader.vue';
import MainButton from '../components/common/mainButton.vue';

const emits = defineEmits(['pasteCode', 'goToShare', 'claimSubmit'])

const props = defineProps<{
    dataSet: GiftCodeData
    isTabView?: boolean
}>()

const couponCode = ref(props.dataSet.couponCode)

watch(
    () => props.dataSet.couponCode,
    val => (couponCode.value = val)
);

const pasteCode = async () => {
    try {
        const text = await navigator.clipboard.readText();
        if (!text) return;

        couponCode.value = text;
        emits('pasteCode', text);
    } catch (err) {
        console.error('Paste failed', err);
    }
};
const claimSubmit = () => {
    emits('claimSubmit', couponCode.value)
}
const goToShare = async () => {
    emits("goToShare")
}

</script>
<style scoped>
.cuponContainer {
    padding: 0px 0;
    min-height: 100vh;
    background: #090F1F;
}

.gift-banner {
    position: relative;
    max-width: 100%;
    margin: 0;
}

.banner-img {
    width: 100%;
}

.btn_container {
    margin: 10px 0 25px;
}

.couponInput {
    margin: 20px 0;
    color: #FFF;
    border: 1px solid #242e48;
    background-color: transparent;
    border-radius: 10px;
}

.mediaIcons {
    border-radius: 10px;
    padding: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 10px 0;
}

.mediaIcons img {
    width: 35px;
    padding: 5px 10px;
}

.bottom_text {
    padding: 25px;
}

.line_text {
    color: rgba(255, 255, 255, 0.45);
    font-size: 15px;
    padding: 10px;
    font-weight: 500;
    line-height: 22.5px;
}

.middleCard {
    display: flex;
    flex-direction: column;
    padding: 0 15px;
}

.top-text {
    color: #FFFFFFD9;
    font-size: 20px;
    font-weight: bold;
    pointer-events: none;
    white-space: nowrap;
}

.couponInput ::v-deep .van-field {
    line-height: 1.64rem !important;
    background: transparent !important;
    font-size: 10px !important;
}

.couponInput ::v-deep .van-field__control {
    font-size: 15px;
    padding: 5px 0px;
    color: #ffffff !important;
}

::v-deep(.pasteInput .van-field__control::placeholder) {
    color: #dfdffb73 !important;
    font-size: 16px;
    font-weight: 500;
}

@media (max-width: 400px) {
    .top-text {
        font-size: 16px;
    }

    ::v-deep(.pasteInput .van-field__control::placeholder) {
        font-size: 14px;
    }
}
</style>